module.exports = __webpack_public_path__ + "img/security-section.4feb71e3.svg";